module.exports = __webpack_public_path__ + "media/images/ui-bg_glass_75_ffffff_1x400-a11bcd6484e89dd354751eed94565ef3.png";